module.exports = __webpack_public_path__ + "static/media/1.28882dec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/4006/1.jpg
// module id = 665
// module chunks = 0